import { useMutation, useQueryClient } from "@tanstack/react-query";
import { agentMailboxSelfService } from "@/services/agent/AgentMailboxSelfService";
import type { AgentMailboxSelfProvisionInput, AgentMailboxUpdateInput } from "@/types/agent-mailboxes";

export const useUpdateAgentMailboxSelf = (agentId: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: AgentMailboxUpdateInput) => agentMailboxSelfService.update(agentId!, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["agent", agentId] }),
  });
};

export const useDeprovisionAgentMailboxSelf = (agentId: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => agentMailboxSelfService.deprovision(agentId!),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["agent", agentId] }),
  });
};

export const useProvisionAgentMailboxSelf = (agentId: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input?: AgentMailboxSelfProvisionInput) => agentMailboxSelfService.provision(agentId!, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["agent", agentId] }),
  });
};

export const useTestAgentMailboxSelf = (agentId: string | undefined) => {
  return useMutation({
    mutationFn: () => agentMailboxSelfService.sendTest(agentId!),
  });
};
